/**
 * As a UX 'feature' iOS will scroll an input with focus into view. Always.
 * Since the designer runs in a window, this behaviour is unwanted at best.
 * As there is no point attempting to prevent this, the following function
 * will reset to last scroll position when needed.
 * @example
 * <Input onFocus={preventMobileAutoScroll} />
 */
export const preventMobileAutoScroll = () => {
    if (window.innerWidth <= 768) {
        window.setTimeout(() => {
            window.scrollTo(-window.scrollX, -window.scrollY);
        }, 60);
    }
};